import { getFetchWrapper } from "../getFetchWrapper.js";
import { accountSummaryV2Url } from "../endpoints.js";
const queryFnFactory = (config, keyProps) => {
  return () => {
    const fetchWrapper = getFetchWrapper(config);
    const params = new URLSearchParams({
      "cipher.accountId": keyProps.accountId
    });
    if (keyProps.accountIdType) {
      params.set("accountIdType", keyProps.accountIdType);
    }
    return fetchWrapper(`${accountSummaryV2Url}?${params}`, {
      method: "GET"
    });
  };
};
export {
  queryFnFactory as default
};
//# sourceMappingURL=query.js.map
